<template>
	<div class="tw-flex tw--mx-3">
		<div class="px-3 tw-w-3/5">
			<model-stepper
				:current-step="2"
				class="tw-mb-4"
				@code-step="loadCodeStep">
			</model-stepper>
			<p-card class="tw-mb-4">
				<div class="tw-px-5">
					<span :style="`color:${$appColors.info}`">
						<b style>Puesto Seleccionado: </b> {{ selectedJobs.name }}
					</span>
				</div>
			</p-card>
			<p-card class="form">
				<form v-if="dataConfigProcess" class="tw-px-5">
					<v-layout row>
						<v-flex xs12>
							<label :style="`color:${$appColors.info}; font-weight: bold;`">
								Nombre del Proceso:
								<input
									class="form-process-input"
									placeholder="Nombre"
									v-model="model.name"
								/>
								<span
									class="form-group__message"
									v-if="!$v.model.name.required"
									:style="`color:${$appColors.error}`">
									El nombre es obligatorio
								</span>
							</label>
						</v-flex> 
					</v-layout>
					<v-layout row tw-mt-3>
						<v-flex v-if="idConfigProcess" xs4 class="tw-mr-2">
							<label :style="`color:${$appColors.info}; font-weight: bold`">
								Fecha Inicio:
								<app-date-flat
									v-if="model.startDate && model.endDate && model.hiringDate"
									v-model="model.startDate"
									:default-date="model.startDate"
									:style="`border-radius:4px;color: ${$appColors.info} !important`"
									@input="setDate({ model: 'model.startDate', value: $event })"
								/>
								<span
									class="form-group__message"
									v-if="!$v.model.startDate.required"
									:style="`color:${$appColors.error}`">
									La Fecha Inicio es obligatoria.
								</span>
							</label>
						</v-flex> 
						<v-flex v-else xs4 class="tw-mr-2">
							<label :style="`color:${$appColors.info}; font-weight: bold`">
								Fecha Inicio:
								<app-date-flat
									v-model="model.startDate"
									:default-date="model.startDate"
									:style="`border-radius:4px;color: ${$appColors.info} !important`"
									@input="setDate({ model: 'model.startDate', value: $event })"
								/>
								<span
									class="form-group__message"
									v-if="!$v.model.startDate.required"
									:style="`color:${$appColors.error}`">
									La Fecha Inicio es obligatoria.
								</span>
							</label>
						</v-flex> 
						<v-flex v-if="idConfigProcess" xs4 class="tw-mx-2">
							<label :style="`color:${$appColors.info}; font-weight: bold`">
								Fecha Fin:
								<app-date-flat
									v-if="model.startDate && model.endDate && model.hiringDate"
									v-model="model.endDate"
									:default-date="model.endDate"
									:style="`border-radius:4px;color: ${$appColors.info} !important`"
									@input="setDate({ model: 'model.endDate', value: $event })"
								/>
								<span
									class="form-group__message"
									v-if="!$v.model.endDate.required"
									:style="`color:${$appColors.error}`">
									La Fecha Fin es obligatoria.
								</span>
							</label>
						</v-flex> 
						<v-flex v-else xs4 class="tw-mx-2">
							<label :style="`color:${$appColors.info}; font-weight: bold`">
								Fecha Fin:
								<app-date-flat
									v-model="model.endDate"
									:default-date="model.endDate"
									:style="`border-radius:4px;color: ${$appColors.info} !important`"
									@input="setDate({ model: 'model.endDate', value: $event })"
								/>
								<span
									class="form-group__message"
									v-if="!$v.model.endDate.required"
									:style="`color:${$appColors.error}`">
									La Fecha Fin es obligatoria.
								</span>
							</label>
						</v-flex> 
						<v-flex v-if="idConfigProcess" xs4 class="tw-ml-2">
							<label :style="`color:${$appColors.info}; font-weight: bold`">
								Fecha de Contratación:
								<app-date-flat
									v-if="model.startDate && model.endDate && model.hiringDate"
									v-model="model.hiringDate"
									:default-date="model.hiringDate"
									:style="`border-radius:4px;color: ${$appColors.info} !important`"
									@input="setDate({ model: 'model.hiringDate', value: $event })"
								/>
								<span
									class="form-group__message"
									v-if="!$v.model.hiringDate.required"
									:style="`color:${$appColors.error}`">
									La Fecha de Contratación es obligatoria.
								</span>
							</label>
						</v-flex>
						<v-flex v-else xs4 class="tw-ml-2">
							<label :style="`color:${$appColors.info}; font-weight: bold`">
								Fecha de Contratación:
								<app-date-flat
									v-model="model.hiringDate"
									:default-date="model.hiringDate"
									:style="`border-radius:4px;color: ${$appColors.info} !important`"
									@input="setDate({ model: 'model.hiringDate', value: $event })"
								/>
								<span
									class="form-group__message"
									v-if="!$v.model.hiringDate.required"
									:style="`color:${$appColors.error}`">
									La Fecha de Contratación es obligatoria.
								</span>
							</label>
						</v-flex> 
					</v-layout>
					<v-layout row tw-mt-3>
						<v-flex xs8 class="tw-mr-2">
							<label :style="`color:${$appColors.info}; font-weight: bold;`">
								Empleado Responsable:
								<v-select
									solo
									class="custom-select-form"
									autocomplete
									:items="employees"
									item-text="fullName"
									item-value="id"
									v-model="model.responsibleEmployee"
									return-object
								></v-select>
								<span
									class="form-group__message"
									v-if="!$v.model.responsibleEmployee.required"
									:style="`color:${$appColors.error}`">
									El Empleado es obligatorio
								</span>
							</label>
						</v-flex> 
						<v-flex xs4 class="tw-ml-2">
							<label :style="`color:${$appColors.info}; font-weight: bold;`">
								Nro. de Vacantes:
								<input
									class="form-process-input"
									placeholder="Nro. de Vacantes"
									v-model="model.vacancy"
								/>
								<span
									class="form-group__message"
									v-if="!$v.model.vacancy.required"
									:style="`color:${$appColors.error}`">
									Nro. de Vacantes es obligatorio
								</span>
								<span
									class="form-group__message"
									v-if="!$v.model.vacancy.numeric"
									:style="`color:${$appColors.error}`">
									Ingresar solo caracteres numéricos
								</span>
							</label>
						</v-flex>
					</v-layout>
					<v-layout row tw-mt-3>
						<v-flex xs12>
							<label :style="`color:${$appColors.info}; font-weight: bold;`">
								Ubicación:
								<input
									class="form-process-input"
									placeholder="Ubicación"
									v-model="model.location"
								/>
								<span
									class="form-group__message"
									v-if="!$v.model.location.required"
									:style="`color:${$appColors.error}`">
									La Ubicación es obligatorio
								</span>
							</label>
						</v-flex>
					</v-layout>
					<v-layout row tw-mt-3>
						<v-flex xs4 class="tw-mr-2">
							<label :style="`color:${$appColors.info}; font-weight: bold;`">
								Márgenes de Remuneración
								<input
									class="form-process-input"
									placeholder="Mínimo"
									v-model="model.remuneration.min"
								/>
								<!-- <span
									class="form-group__message"
									v-if="!$v.model.remuneration.min.required"
									:style="`color:${$appColors.error}`">
									Remuneracíon Mínima obligatoria
								</span> -->
								<!-- <span
									class="form-group__message"
									v-if="!$v.model.remuneration.min.numeric"
									:style="`color:${$appColors.error}`">
									Ingresar solo caracteres numéricos
								</span> -->
							</label>
						</v-flex> 
						<v-flex xs4 class="tw-ml-2 tw-mt-6">
							<label :style="`color:${$appColors.info}; font-weight: bold;`">
								<input
									class="form-process-input"
									placeholder="Máximo"
									v-model="model.remuneration.max"
								/>
								<!-- <span
									class="form-group__message"
									v-if="!$v.model.remuneration.max.required"
									:style="`color:${$appColors.error}`">
									Remuneracíon Máxima obligatoria
								</span>
								<span
									class="form-group__message"
									v-if="!$v.model.remuneration.max.numeric"
									:style="`color:${$appColors.error}`">
									Ingresar solo caracteres numéricos
								</span> -->
							</label>
						</v-flex>
					</v-layout>
				</form>
				<p-horizontal-divider/>
				<div class="tw-flex tw-justify-center tw-gap-x-4">
					<p-button
						type="secondary"
						@click="goTo(validateReturnButton)">Atrás
					</p-button>
					<p-button
						type="primary"
						:disabled="!isValidated"
						@click="saveConfigProcess">Siguiente
					</p-button>
				</div>
			</p-card>
		</div>
		<div class="px-3 tw-w-2/5 fixed-section">
			<model-description
				:title="'PROCESO DE SELECCIÓN'"
				:subtitle="'DESCRIPCIÓN'">
				<div class="tw-my-4 tw-flex tw-flex-col tw-text-center tw-justify-center tw-items-center" slot="content">
					<p class="tw-mb-12 tw-text-left">
						1. Selecciona los puestos que ingresarán al proceso de selección.<br>
						2. Configura el proceso.<br>
						3. Configura las actividades del proceso de selección.<br>
						4. Configura la plantilla para la entrevista.
					</p>
					<p-button
						type="primary"
					>Mire nuestro tutorial paso a paso</p-button>
				</div>
			</model-description>
		</div>
	</div>
</template>

<script>
import modelStepper from '@/modules/recruitment/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import SquareBox from '@/modules/shared/components/content/SquareBox';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import helper from '@/shared/helper';
import appDateFlat from '@/components/shared/app-date-flat';
import { required, numeric } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import { map, pathOr } from 'ramda';
import { differenceInCalendarDays, format } from 'date-fns';

const { getLocalData } = helper;

export default {
	name: 'step-config-process-recruitment',
	data() {
		return {
			codeStep: {},
			employees: [],
			model: {
				name: null,
				startDate: null,
				endDate: null,
				hiringDate: null,
				responsibleEmployee: null,
				vacancy: null,
				location: null,
				remuneration: {
					max: null,
					min: null,
				},
			},
			codeProcess: null,
		};
	},
	beforeCreate() {
		this.$store.dispatch('recruitment/loadRecruitmentConfig');
		const code = 'CPR';
		this.$store.dispatch('recruitment/loadConfigProcess', code);
	},
	created() {
		this.listEmployees();
	},
	beforeMount() {
	},
	mounted() {
		const response = this.dataConfigProcess.details;
		this.codeProcess = this.dataConfigProcess && this.dataConfigProcess.code
			? this.dataConfigProcess.code : null;
		if (Object.keys(response).length > 1) {
			this.model.name = response.name;
			this.model.startDate = response.startDate;
			this.model.endDate = response.endDate;
			this.model.hiringDate = response.hireDate;
			this.model.responsibleEmployee = response.responsibleEmployeId;
			this.model.vacancy = response.vacancyNumber;
			this.model.location = response.location;
			this.model.remuneration.max = response.remunerationMargins.max === 0
				? null : response.remunerationMargins.max;
			this.model.remuneration.min = response.remunerationMargins.min === 0
				? null : response.remunerationMargins.min;
		}
	},
	validations() {
		return {
			model: {
				name: { required },
				startDate: { required },
				endDate: { required },
				hiringDate: { required },
				responsibleEmployee: { required },
				vacancy: { required, numeric },
				location: { required },
				// remuneration: {
				// 	max: { required, numeric },
				// 	min: { required, numeric },
				// },
			},

		};
	},
	components: {
		modelStepper,
		PCard,
		SquareBox,
		modelDescription,
		PButton,
		PHorizontalDivider,
		appDateFlat,
	},
	methods: {
		loadCodeStep(obj) {
			this.codeStep = obj;
		},
		setDate({ model, value }) {
			this[model] = value;
		},
		async listEmployees() {
			try {
				({ data: this.employees } = await this.$httpPraktiko.get('employee'));
				const addFullName = obj => ({ ...obj, fullName: `${obj.name} ${obj.lastName}` });
				this.employees = map(addFullName, this.employees);
			} catch (error) {
				if (error.status === 500) {
					this.showGenericError();
				}
			}
		},
		async saveConfigProcess() {
			const body = {
				code: this.codeProcess ? this.codeProcess
					: this.model.name.toLowerCase().replace(/\s+/g, ''),
				jobId: this.selectedJobs.id,
				typeRecruitmentCode: this.codeStep.code,
				details: {
					name: this.model.name,
					startDate: format(this.model.startDate, 'YYYY-MM-DD HH:mm'),
					endDate: format(this.model.endDate, 'YYYY-MM-DD HH:mm'),
					hireDate: format(this.model.hiringDate, 'YYYY-MM-DD HH:mm'),
					responsibleEmployeId: {
						id: this.model.responsibleEmployee.id,
						fullName: this.model.responsibleEmployee.fullName,
					},
					vacancyNumber: Number(this.model.vacancy),
					location: this.model.location,
					remunerationMargins: {
						min: this.model.remuneration.min ? Number(this.model.remuneration.min) : 0,
						max: this.model.remuneration.max ? Number(this.model.remuneration.max) : 0,
					},
				},
			};
			if (this.idConfigProcess) {
				body.id = this.idConfigProcess;
			}
			try {
				const { data: response } = await this.$httpPraktiko.post('/recruitment', body);
				if (response.id) {
					this.$store.dispatch('recruitment/saveIdConfigProcess', response.id);
				}
				this.$store.dispatch('recruitment/loadConfigProcess', this.codeStep.code);
				this.showNotification('Proceso Guardado Exitosamente');
				this.goTo(this.codeStep.goTo);
			} catch (error) {
				this.showGenericError();
			}
		},
	},
	computed: {
		...mapState('recruitment', {
			selectedJobs(state) {
				return pathOr(getLocalData('jobSelected'), ['recruitmentFlow', 'selectedJobs'], state.recruitment) || [];
			},
			idConfigProcess(state) {
				return pathOr(getLocalData('idConfigProcess'), ['idConfigProcess'], state.recruitment) || null;
			},
			dataConfigProcess(state) {
				return pathOr(getLocalData('dataConfigProcess'), ['dataConfigProcess'], state.recruitment) || [];
			},
			flagEditProcess: pathOr(false, ['recruitmentFlow', 'flagEditProcess']),
		}),
		isValidated() {
			const datesValid = differenceInCalendarDays(this.model.startDate, this.model.endDate) <= 0;
			if (!datesValid) {
				this.showNotification('La Fecha Inicio o debe supera la Fecha Fin', 'warning');
			}
			return (
				this.$v.model.name.required &&
				this.$v.model.startDate.required &&
				this.$v.model.endDate.required &&
				this.$v.model.hiringDate.required &&
				this.$v.model.responsibleEmployee.required &&
				this.$v.model.vacancy.required &&
				this.$v.model.vacancy.numeric &&
				// this.$v.model.remuneration.min.required &&
				// this.$v.model.remuneration.min.numeric &&
				// this.$v.model.remuneration.max.required &&
				// this.$v.model.remuneration.max.numeric &&
				datesValid
			);
		},
		validateReturnButton() {
			this.$store.dispatch('recruitment/saveIdConfigProcess');
			this.$store.dispatch('recruitment/toggleJobSelection');
			return !this.flagEditProcess ? this.codeStep.returnTo : 'list-process-recruitment';
		},
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.form-process {
	bottom: 0;
	left: 0;
	padding: 0;
	position: relative !important;
	right: 0;

	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, green-dark);
		border-radius: 4px;
        display: block;
        outline: none;
		color: map-get($colors, secondary);
		margin-top: 4px;
		padding: 10px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
.fixed-section {
	width: 30% !important;
	position: fixed;
	right: 95px;
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/steps-recruitment/step-config-process-recruitment.vue